import appConfig from '../../../config/appConfig';

var dashboardConfig = {
  apiUrl: appConfig.apiUrl + 'dashboard/'
};

export default dashboardConfig;



// WEBPACK FOOTER //
// ./src/components/dashboard/config/dashboardConfig.js